<!--

Info box renders colored bordered box with icon on the left and text on the right.

TODO make it dynamic by:
  - accepting variant or info by default(background color - info, warning, danger...)
  - accepting icon or displaying the default one

-->

<template>
  <div class="info-box flex flex-align-center">
    <SBIcon
      class="mr-3"
      :icon="SBIconList.TRIANGLE_EXCLAMATION"
      :color="SBColors.$blackPrimary"
      :size="12"/>
    <slot name="content"/>
  </div>
</template>

<script>
import SBColors from '@/helpers/lists/colors';
import SBIconList from '@/helpers/lists/sb-icon-list';
import SBIcon from '@/components/common/Icon';

export default {
  name: 'InfoBox',
  components: {
    SBIcon,
  },
  props: {
    variant: {
      type: String,
      required: false,
      default: 'INFO',
    },
  },
  data() {
    return {
      SBColors,
      SBIconList,
    };
  },
};
</script>

<style lang="scss" scoped>
.info-box {
  margin: 0;
  padding: 11px 15px;
  border-radius: 5px;
  border: solid 1px #f8e9e9;
  background-color: #fff7dd;
}
</style>
